/**
 * Generated runtime TestId mirror for frontend/src/features/notifications/NotificationDetail.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const NotificationDetailTestIds = {
  cardNotificationDetail: "card-notification-detail",
  cardTitleGoToReference: "card-title-go-to-reference",
  linkReferencedEntity: "link-referenced-entity",
  notificationDetailPage: "notification-detail-page",
  notificationMessage: "notification-message"
} as const;
